import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=791f70a2&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
import style0 from "@/vendor/libs/vue-form-wizard/vue-form-wizard.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Wizard.vue?vue&type=style&index=1&id=791f70a2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f70a2",
  null
  
)

export default component.exports